<template>
  <modal-template v-if="readyToShow">
    <template #header>
      <div class="modal-header-style">
        <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
          <span>assign users</span>
        </div>
        <div style="float:right;">
          <label class="action-icon-style" v-on:click="$emit('close', true)">
            <font-awesome-icon icon="xmark" size="xl"/>
            <span style="display: block;">close</span>
          </label>
        </div>
      </div>
      <div style="width:100%;float:left;color:black;border-bottom:1px solid black;">
        <div style="width:100%;float:left;">
          <span style="font-size:larger;font-weight:bold;">
            <sup>[{{ account.customerId }}]</sup> {{ account.customerName }}
          </span>
        </div>
        <div style="width:100%;float:left;">
          <span>
            serviced by <sup>[{{ account.dairyId }}]</sup> {{ account.dairyName }}
          </span>
        </div>
      </div>
    </template>
    <template #body>
      <div class="table-container">
        <table>
          <thead>
          <tr>
            <th colspan="2">
              <div style="display:flex;justify-content:space-between;">
                <div style="float:left;padding-top:3%">
                  <span>assigned users</span>
                </div>
                <div style="float:right;text-align:right;">
                  <input v-model="newUser"
                         class="login-input"
                         style="width:90%;"
                         autofocus
                         type="email"
                         placeholder="new user's email address"
                         size="30"
                         autocomplete="off"
                         :class="{'valid-email-address-format' : !validEmailAddress}"/>
                </div>
              </div>
            </th>
            <th style="width:10%;text-align:right;">
              <label class="order-icon-style" v-on:click="add">
                <font-awesome-icon icon="user-plus" size="xl"/>
                <span style="display: block;">add</span>
              </label>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in users" :key="user">
            <td>
              <span>{{ user }}</span>
            </td>
            <td style="display:flex;justify-content:space-between;">
              <label class="order-icon-style" v-on:click="email(user)">
                <font-awesome-icon icon="envelope" size="xl"/>
                <span style="display: block;">send reset</span>
              </label>
              <label class="order-icon-style" v-on:click="resetProductSort(user)">
                <font-awesome-icon icon="arrow-down-a-z" size="xl"/>
                <span style="display: block;">reset sort</span>
              </label>
              <label class="order-icon-style" v-on:click="remove(user)">
                <font-awesome-icon icon="user-large-slash" size="xl"/>
                <span style="display: block;">remove</span>
              </label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
    </template>
  </modal-template>
  <product-sort-reset-confirmation v-if="resetSort"
                                   :account="account"
                                   :username="selectedUsername"
                                   @close="resetSort = false"
  />
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'
import ProductSortResetConfirmation from '@/components/administrator/account/ProductSortRestConfirmation'

export default {
  name: 'UserList',
  props: ['account'],
  emits: ['close', 'apierror', 'apierrortext'],
  components: {
    ModalTemplate,
    ProductSortResetConfirmation,
  },
  data: function () {
    return {
      users: [],
      newUser: '',
      confirm: false,
      removeUser: null,
      readyToShow: false,
      validEmailAddress: false,
      resetSort: false,
      selectedUsername: '',
    }
  },
  methods: {
    add: function () {
      this.axios
          .get('email/isValid',
              {
                params: {
                  emailAddress: this.newUser
                }
              })
          .then(response => {
            this.validEmailAddress = response.data

            if (this.validEmailAddress && !_.includes(this.users, this.newUser)) {
              this.axios
                  .post('assignment/add', {
                    dairyId: this.account.dairyId,
                    dairyName: this.account.dairyName,
                    customerId: this.account.customerId,
                    customerName: this.account.customerName,
                    user: this.newUser
                  })
                  .then(response => {
                    if (response.statusText === 'OK') {
                      this.users.push(this.newUser)
                      this.newUser = ''
                    }
                  })
                  .catch(error => {
                    this.validEmailAddress = false
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                  })
            }
          })
          .catch(error => {
            this.validEmailAddress = false
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
    },
    email: function (user) {
      this.axios
          .post('user/adminRequestReset', {
            dairyId: this.account.dairyId,
            dairyName: this.account.dairyName,
            customerId: this.account.customerId,
            customerName: this.account.customerName,
            user: user
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
    },
    remove: function (user) {
      this.axios
          .post('assignment/remove', {
            dairyId: this.account.dairyId,
            dairyName: this.account.dairyName,
            customerId: this.account.customerId,
            customerName: this.account.customerName,
            user: user
          })
          .then(response => {
            if (response.statusText === 'OK') {
              _.pull(this.users, user)
              this.selectedUser = ''
            }
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
    },
    resetProductSort: function (username) {
      this.selectedUsername = username
      this.resetSort = true
    },
    setApiError: function (isError) {
      this.$emit('apierror', isError)
    },
    setApiErrorText: function (text) {
      this.$emit('apierrortext', text)
    },
  },
  mounted() {
    this.validEmailAddress = true

    this.axios
        .get('assignment/listUsers', {
          params: {
            dairyId: this.account.dairyId,
            customerId: this.account.customerId,
          }
        })
        .then(response => {
          this.users = response.data
          this.newUser = ''
          this.readyToShow = true
        })
        .catch(error => {
          this.setApiError(true)
          this.setApiErrorText(error.response.statusText)
        })
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.valid-email-address-format {
  padding: 12px 15px;
  margin: 8px 0;
  width: 20%;
  font-size: 12pt;
  background: #ffdddd;
  border: 1px solid red;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}

.order-icon-style {
  color: black;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.order-icon-style:hover {
  font-weight: bolder;
}

ul li {
  display: inline-block;
}
</style>
